export enum applicantsTypes {
  FETCH_APPLICANTS_REQUEST = "FETCH_APPLICANTS_REQUEST",
  FETCH_APPLICANTS_SUCCESS = "FETCH_APPLICANTS_SUCCESS",
  FETCH_APPLICANTS_FAILURE = "FETCH_APPLICANTS_FAILURE",
}